module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr>\n    <td class=\"gridview-column\">\n        <control title=\"Месяцы\" type=\"text\" target=\"item.config.calendar[")
    ; __append(escapeFn(item.id))
    ; __append("].months\" html-name=\"months\" html-placeholder=\"Введите месяцы\" on-click=\"onItemChange\"></control>\n    </td>\n    <td class=\"gridview-column\">\n        <control title=\"Дни\" type=\"text\" target=\"item.config.calendar[")
    ; __append(escapeFn(item.id))
    ; __append("].days\" html-name=\"months\" html-placeholder=\"Введите дни\" on-click=\"onItemChange\"></control>\n    </td>\n    <td class=\"gridview-column\">\n        <div style=\"width: 30px; text-align: center\"><div on-click=\"onItemDelete\" name=\"remove-button\" class=\"icon-trash-o icon-16\" data-item=\"")
    ; __append(escapeFn( JSON.stringify(item) ))
    ; __append("\"></div></div>\n    </td>\n</tr>")
  }
  return __output.join("");

}